import type { DateTimeMode } from "../../types.ts";
import type { NativeInputType, RenderContext, RenderField } from "../types.ts";
import { renderTextLikeField } from "./text-input.ts";

const nativeTypeForMode: Record<DateTimeMode, NativeInputType> = {
  both: "datetime-local",
  date: "date",
  time: "time",
};

export const renderDateTimeField = (
  field: RenderField<"DATETIME">,
  context: RenderContext,
): HTMLElement => {
  const mode = field.configJson.mode;
  const inputType = nativeTypeForMode[mode];

  return renderTextLikeField(field, context, inputType, (input) => {
    // Time-bearing modes capture minute precision. A 60-second step keeps the
    // native picker on whole minutes and matches the normalized submission value.
    if (mode === "time" || mode === "both") {
      input.step = "60";
    }
  });
};
